import { USER_EMAIL, USER_PASSWORD } from '@/mocks/adminData';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const logoUrl = '/img/logo.png';

function AdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!email.trim() || !password.trim()) {
      setError('Preencha todos os campos para continuar.');
      return;
    }

    setLoading(true);

    // Simula delay de autenticação
    setTimeout(() => {
      if (email === USER_EMAIL && password === USER_PASSWORD) {
        localStorage.setItem('admin_logged_in', 'true');
        navigate('/admin');
      } else {
        setError('E-mail ou senha incorretos. Tente novamente.');
      }
      setLoading(false);
    }, 800);
  };

  return (
    <div className="min-h-screen bg-background-50 flex items-center justify-center px-4">
      <div className="w-full max-w-[400px]">
        {/* Logo */}
        <div className="text-center mb-8">
          <img src={logoUrl} alt="Maçã Verde" className="w-16 h-16 rounded-full object-cover mx-auto mb-4" />
          <h1 className="font-heading text-xl font-semibold text-foreground-900">Acessar painel administrativo</h1>
          <p className="text-sm text-foreground-500 mt-1">Maçã Verde</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="bg-white rounded-xl border border-background-200 p-6 space-y-4">
          {error && (
            <div className="flex items-center gap-2 px-3 py-2.5 rounded-lg bg-red-50 border border-red-200 text-red-700 text-sm">
              <i className="ri-error-warning-line flex-shrink-0" />
              {error}
            </div>
          )}

          <div>
            <label htmlFor="login-email" className="block text-xs font-medium text-foreground-700 mb-1.5">
              E-mail
            </label>
            <input
              id="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@macaverde.com.br"
              className="w-full px-3 py-2.5 rounded-lg text-sm border border-background-300 bg-background-50 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-shadow"
            />
          </div>

          <div>
            <label htmlFor="login-password" className="block text-xs font-medium text-foreground-700 mb-1.5">
              Senha
            </label>
            <input
              id="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••"
              className="w-full px-3 py-2.5 rounded-lg text-sm border border-background-300 bg-background-50 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-shadow"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-full bg-primary-600 text-white text-sm font-semibold hover:bg-primary-700 disabled:opacity-60 disabled:cursor-not-allowed transition-colors whitespace-nowrap"
          >
            {loading ? (
              <>
                <i className="ri-loader-4-line animate-spin" />
                Entrando...
              </>
            ) : (
              'Entrar'
            )}
          </button>

          <p className="text-center">
            <button
              type="button"
              className="text-xs text-foreground-500 hover:text-primary-600 transition-colors"
              onClick={() => alert('Funcionalidade de recuperação de senha será implementada em breve.')}
            >
              Esqueci minha senha
            </button>
          </p>
        </form>
      </div>
    </div>
  );
}

export default AdminLoginPage;